import React from 'react'
import { RouteProps } from 'react-router-dom'
import { ContextualMenu } from '../Menus/ContextualMenu';
import { observer } from "mobx-react";
import { IContextualMenu } from '../Menus/interfaces/IContextualMenu';
import Store from "../store/store";
import MenuNavigation from '../Menus/menuNavigation/MenuNavigation';
const styles = require("../../styles/styles.module.scss");


interface ILayoutProps {
  menuContextuel: IContextualMenu;
  component: any;
  menuSharepoint: boolean;
}

interface ILayoutState {
  mobile: boolean;
}

@observer
export default class Layout extends React.Component<RouteProps & ILayoutProps, ILayoutState> {
  constructor(props: RouteProps & ILayoutProps) {
    super(props);
    this.state = {
      mobile: window.innerWidth < 768
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.checkIfMobileOrNot);
  }

  componentDidUpdate(prevProps: RouteProps & ILayoutProps, prevState: ILayoutState) {
    if (prevProps.path != this.props.path && this.props.path != "/document") {
      this.resetContextualMenu();
    }
  }

  private checkIfMobileOrNot = () => {
    this.setState({ mobile: window.innerWidth < 768 });
  }

  private resetContextualMenu: () => void = () => {
    Store.contextualmenu = Store.defaultValueContextualMenu;
  }

  public onCloseContextualMenu: () => void = () => {
    if (this.props.menuContextuel.open == "extended" && this.props.menuContextuel.content == "ActionsWorkflow") { // Pour activer le menu contextuel réduit que sur certaines pages particulières
      Store.contextualmenu.open = "open";
    }
    else if (this.props.menuContextuel.open == "extended" && this.props.menuContextuel.content == "editDatedeFinsouhaitee") { // Pour activer le menu contextuel réduit si on ferme la modif de la date
      Store.contextualmenu = {
        open: "open",
        content: "ActionsWorkflow"
      };
    }
    else if (this.props.menuContextuel.open == "open" && this.props.menuContextuel.content == "ActionWorkflow") { // Pour activer le menu contextuel réduit que sur certaines pages particulières 
      Store.contextualmenu.open = "extended";
    }
    else if (this.props.menuContextuel.open == "extended") {
      Store.contextualmenu = Store.defaultValueContextualMenu;
    }
    else if (this.props.menuContextuel.open == "open") {
      Store.contextualmenu.open = "extended";
    }
  }

  render() {
    const { component: Component, menuContextuel, menuSharepoint, ...rest } = this.props;
    // const Component = this.props.component;
    let settings = {}
    let css: React.CSSProperties = {}

    // Cas pour le menu
    if (this.state.mobile) {
      css.marginTop = "55px";
      css.marginLeft = "5px";
    }
    else {
      if (menuSharepoint == true) {
        css.marginLeft = "255px";
      } else {
        css.marginLeft = "75px";
      }
    }

    // Cas pour le menu contextuel
    if (menuContextuel.open == "open" && window.innerWidth > 768) {
      css.marginRight = "65px";
    }
    else if (menuContextuel.open == "extended" && window.innerWidth > 768) {
      css.marginRight = "280px";
    }
    else if (menuContextuel.open == "open" && window.innerWidth <= 768) {
      css.marginRight = "55px";
    }
    else if (menuContextuel.open == "extended" && window.innerWidth <= 768) {
      css.marginRight = "10px";
    }
    else {
      css.marginRight = "5px";
    }

    settings = { style: css }

    let cssMenuContextual: React.CSSProperties = {};

    if (menuContextuel.open == "extended" && menuContextuel.content == "viewModelWf") {
      cssMenuContextual = { right: 0, width: "550px" }
    }
    else if (menuContextuel.open == "hidden" && menuContextuel.content == "viewModelWf") {
      cssMenuContextual = { right: "-560px", width: "550px" }
    }
    else if (menuContextuel.open == "hidden" && menuContextuel.content != "viewModelWf") {
      cssMenuContextual = { right: "-310px", width: "256px" }
    }
    else if (menuContextuel.open == "extended" && menuContextuel.content != "viewModelWf") {
      cssMenuContextual = { right: 0, width: "256px" }
    }

    // test Thomas
    if (menuContextuel.open == "hidden") {
      cssMenuContextual = { right: "-310px", width: "256px" }
    }
    else if (menuContextuel.open == "open") {
      cssMenuContextual = { right: "-204px", width: "256px" }
    }
    else if (menuContextuel.open == "extended") {
      cssMenuContextual = { right: 0, width: "256px" }
    }
    return (
      <React.Fragment>
        <div className={styles.content}>
          <div className={styles.contentMenu}>
            <MenuNavigation mobile={this.state.mobile} />
          </div>
          {/* Pour réinitialiser les marges du menu au changement d ecrans */}
          <div {...settings} id={"contentComponentClose"} className={styles.contentComponent}>
            <Component {...rest} />
          </div>
          <div className={styles.contentContextual} style={cssMenuContextual}>
            <ContextualMenu onCloseContextualMenu={this.onCloseContextualMenu} menuOpen={menuContextuel.open} menuContent={menuContextuel.content} />
          </div>
        </div>
      </React.Fragment>
    );
  }
}